<template>
    <div>
        <!-- Begin Page Content -->
        <div class="check-details">
            <div class="row">
                <div class="col-md-12 col-12 mb-4">
                    <div class="bg-white border-radius-5 p-4">
                        <div class="row no-gutters">
                            <div class="col-md-12">
                                <div class="d-flex justify-content-between align-items-center bg-white border-1 border-radius-8 px-4 py-3">
                                    <div class="left-sec">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h2 class="mr-4">Comprehensive Full Body Checkup</h2>
                                            <div class="Safe-button-details">
                                                <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                            </div>
                                        </div>
                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                    </div>
                                    <div class="right-sec d-flex justify-content-between align-items-center">
                                        <div class="price mr-4">
                                            <h2 class="d-flex justify-content-between">$10 <span class="amount ml-2">$20</span></h2>
                                            <p class="green">50% off</p>
                                        </div>
                                        <router-link  class="btn btn-blue Add-to-cart" to="/order-dna-kit">Add to cart</router-link >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutter mt-5">
                            <div class="col-md-10">
                                <h4 class="mb-3">Overview of Comprehensive Full Body Checkup</h4>
                                <div class="checkups-body">
                                    <h3>How Comprehensive Full Body Checkup helps you?</h3>
                                    <p>
                                        It is well known that ‘prevention is better than cure’ and this package is designed specifically for that purpose. It includes a unique diagnostic profile of tests for a comprehensive health
                                        evaluation at an early age. It screens the most common health conditions related to thyroid, heart, liver, kidney, bones and blood. Additionally, it also tests for vitamins like Vitamin B12
                                        and Vitamin D. You should get this package done if you are above 30 years of age and want a thorough evaluation of the overall health status of your body.
                                    </p>
                                </div>
                                <div class="checkups-body Precautions">
                                    <h3>Precautions</h3>
                                    <p class="px-4 py-3">Do not eat or drink anything other than water for 8-12 hours before the test.</p>
                                </div>
                                <div class="checkups-body">
                                    <h3>Package Tests Included in Comprehensive Full Body Checkup(91 tests)</h3>
                                    <ul class="mb-0">
                                        <li>Nitrites</li>
                                        <li>Vitamin B12</li>
                                        <li>Glycosylated Hemoglobin</li>
                                        <li>Microalbumin/Creatinine Ratio</li>
                                        <li>Rheumatoid Factor - Qualitative</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="medical-records checkup-section">
            <div class="row">
                <div class="col-md-12 col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body p-0">
                            <div class="bg-body border-radius-5">
                                <div class="card-header border-0 d-flex d-flex justify-content-between align-items-center bg-body p-0">
                                    <h2 class="mb-0">Related Checkup</h2>
                                </div>
                                <div class="card-body p-0 mt-4">
                                    <div class="row no-gutter">
                                        <div class="col-md-4 col-sm-12 pl-3 mb-4">
                                            <div class="Comprehensive text-center bg-white border-1 border-radius-8 p-3 position-relative">
                                                <div class="Checkup text-left d-flex justify-content-between mb-2">
                                                    <h3>Comprehensive Full Body Checkup</h3>
                                                    <div class="Safe-button">
                                                        <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                    </div>
                                                </div>
                                                <div class="Includes">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h4 class="mb-o">Includes 91 Tests</h4>
                                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                    </div>
                                                    <ul class="mb-3">
                                                        <li><a href="#">Nitrites</a></li>
                                                        <li><a href="#">Glycosylated Hemoglobin</a></li>
                                                        <li><a href="#">Vitamin B12</a></li>
                                                        <li><a href="#">Microalbumin/Creatinine Ratio</a></li>
                                                    </ul>
                                                    <a href="#" class="more-test d-flex align-items-center"><i class="icon icon-plus"></i>more</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-12 pl-3 mb-4">
                                            <div class="Comprehensive text-center bg-white border-1 border-radius-8 p-3 position-relative">
                                                <div class="Checkup text-left d-flex justify-content-between mb-2">
                                                    <h3>Comprehensive Full Body Checkup</h3>
                                                    <div class="Safe-button">
                                                        <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                    </div>
                                                </div>
                                                <div class="Includes">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h4 class="mb-o">Includes 91 Tests</h4>
                                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                    </div>
                                                    <ul class="mb-3">
                                                        <li><a href="#">Nitrites</a></li>
                                                        <li><a href="#">Glycosylated Hemoglobin</a></li>
                                                        <li><a href="#">Vitamin B12</a></li>
                                                        <li><a href="#">Microalbumin/Creatinine Ratio</a></li>
                                                    </ul>
                                                    <a href="#" class="more-test d-flex align-items-center"><i class="icon icon-plus"></i>more</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-12 mb-4">
                                            <div class="Comprehensive text-center bg-white border-1 border-radius-8 p-3 position-relative">
                                                <div class="Checkup text-left d-flex justify-content-between mb-2">
                                                    <h3>Comprehensive Full Body Checkup</h3>
                                                    <div class="Safe-button">
                                                        <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                    </div>
                                                </div>
                                                <div class="Includes">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h4 class="mb-o">Includes 91 Tests</h4>
                                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                    </div>
                                                    <ul class="mb-3">
                                                        <li><a href="#">Nitrites</a></li>
                                                        <li><a href="#">Glycosylated Hemoglobin</a></li>
                                                        <li><a href="#">Vitamin B12</a></li>
                                                        <li><a href="#">Microalbumin/Creatinine Ratio</a></li>
                                                    </ul>
                                                    <a href="#" class="more-test d-flex align-items-center"><i class="icon icon-plus"></i>more</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "Checkup-details",
        data() {
            return {};
        },
        created(){
           this.pageName('Upload Reports')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/checkup/Checkup-details.vue